<template>
  <div>
    <div v-if="orderInfo" style="margin-bottom: 10px">
      <el-card shadow="hover">
        <warehouse-order-info :orderInfo="orderInfo" />
      </el-card>
    </div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="拣货照片" prop="riderPickingPhoto">
            <x-upload
              type="image"
              imageAlign="start"
              :fileCount="4"
              :fileSize="10 * 1024"
              :imageViewWidth="180"
              :imageViewHeight="180"
              v-model="editModel.riderPickingPhoto"
            ></x-upload>
          </el-form-item>
          <el-form-item label="商品清单" prop="itemList">
            <div style="padding: 0px">
              <warehouse-goods-select
                :storeGuid="editModel.storeGuid"
                :params="goodsSelectParams"
                :multipleable="true"
                placeholder="添加商品"
              >
                <template slot="info-append" slot-scope="scope">
                  <div v-if="scope.info" class="shelf-info">
                    {{ scope.info.shelfList }}
                  </div>
                  <div style="margin-top: 10px">
                    <template v-if="getItemByGoodsGuid(scope.info.guid)">
                      <el-input
                        type="number"
                        v-model="getItemByGoodsGuid(scope.info.guid).goodsPrice"
                        @change="
                          handleItemGoodsChange(getItemByGoodsGuid(scope.info.guid))
                        "
                        style="width: 140px; margin-right: 10px"
                        size="small"
                        placeholder="商品单价"
                        :disabled="!!getItemByGoodsGuid(scope.info.guid).isDelete"
                        :min="1"
                      >
                        <template slot="prepend">商品单价</template>
                      </el-input>
                      <el-input-number
                        type="number"
                        v-model="getItemByGoodsGuid(scope.info.guid).goodsCount"
                        @change="
                          handleItemGoodsChange(getItemByGoodsGuid(scope.info.guid))
                        "
                        style="width: 140px; margin-right: 10px"
                        size="small"
                        :disabled="!!getItemByGoodsGuid(scope.info.guid).isDelete"
                        :min="1"
                      >
                        <template slot="prepend">数量</template>
                      </el-input-number>
                      <el-button
                        size="small"
                        type="danger"
                        v-if="!getItemByGoodsGuid(scope.info.guid).guid"
                        @click="removeItemClick(getItemByGoodsGuid(scope.info.guid))"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="getItemByGoodsGuid(scope.info.guid).guid"
                        :type="
                          getItemByGoodsGuid(scope.info.guid).isDelete
                            ? 'primary'
                            : 'danger'
                        "
                        :underline="false"
                        @click="deleteItemClick(getItemByGoodsGuid(scope.info.guid))"
                      >
                        {{
                          getItemByGoodsGuid(scope.info.guid).isDelete
                            ? "取消删除"
                            : "标记删除"
                        }}
                      </el-link>
                    </template>
                    <template v-else>
                      <el-button
                        size="small"
                        type="primary"
                        @click="handleAddItem(scope.info)"
                      >
                        添加到清单
                      </el-button>
                    </template>
                  </div>
                </template>
              </warehouse-goods-select>
              <el-table
                stripe
                v-if="editModel.itemList && editModel.itemList.length > 0"
                :data="editModel.itemList"
                :cell-class-name="delLine"
                :size="$xUISize"
              >
                <el-table-column label="商品信息" min-width="380px">
                  <template slot-scope="scope">
                    <div style="margin-right: 10px">
                      <goods-sku-info
                        :skuInfo="scope.row.goodsInfo && scope.row.goodsInfo.skuInfo"
                      />
                      <div v-if="scope.row.goodsInfo" class="shelf-info">
                        {{ scope.row.goodsInfo.shelfList }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品单价" width="180px">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.goodsPrice"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="商品单价"
                      style="width: 140px"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="商品数量" width="200px">
                  <template slot-scope="scope">
                    <el-input-number
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.goodsCount"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="商品数量"
                      style="width: 140px"
                      :min="0"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="!scope.row.guid"
                      @click="removeItemClick(scope.row)"
                    >
                      移出
                    </el-button>
                    <el-link
                      v-if="scope.row.guid"
                      :type="scope.row.isDelete ? 'primary' : 'danger'"
                      :underline="false"
                      @click="deleteItemClick(scope.row)"
                    >
                      {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="订单备注" prop="userRemark">
            <el-input
              type="textarea"
              v-model="editModel.userRemark"
              :rows="2"
              maxlength="512"
              placeholder="输入订单备注"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="订单异常" prop="errorMessage">
            <el-input
              type="textarea"
              v-model="editModel.errorMessage"
              :rows="2"
              maxlength="512"
              placeholder="输入订单异常说明信息"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单收入"
            prop="orderReceivedAmount"
            key="orderReceivedAmount"
          >
            <el-input
              type="number"
              v-model="editModel.orderReceivedAmount"
              placeholder="请输入订单收入"
            ></el-input>
          </el-form-item>
          <el-form-item label="追单金额" prop="orderAppendAmount" key="orderAppendAmount">
            <el-input
              type="number"
              v-model="editModel.orderAppendAmount"
              placeholder="请输入追单金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="配送成本" prop="freightCost" key="freightCost">
            <el-input
              type="number"
              v-model="editModel.freightCost"
              placeholder="请输入配送成本"
            ></el-input>
          </el-form-item>
          <el-form-item label="打赏骑手" prop="riderRewardAmount" key="riderRewardAmount">
            <el-input
              type="number"
              v-model="editModel.riderRewardAmount"
              placeholder="请输入打赏骑手"
            ></el-input>
          </el-form-item>
          <el-form-item label="骑手姓名" prop="riderName">
            <el-input
              type="text"
              v-model="editModel.riderName"
              maxlength="32"
              placeholder="输入骑手姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="骑手电话" prop="riderPhone">
            <el-input
              type="text"
              v-model="editModel.riderPhone"
              maxlength="32"
              placeholder="输入骑手电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="
                editSubmit || !editModel.itemList || editModel.itemList.length <= 0
              "
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<style>
.shelf-info {
  font-size: 20px;
  font-weight: bolder;
  margin-bottom: 10px;
  color: #e87431;
}
</style>

<script>
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import warehouseOrderInfo from "../../../../components/business/warehouseOrderInfoByChannel.vue";
import warehouseGoodsSelect from "../../../../components/business/warehouseGoodsSelect.vue";

const defaultModel = {
  itemList: [],
};

export default {
  components: {
    goodsSkuInfo,
    goodsSkuSelect,
    warehouseOrderInfo,
    warehouseGoodsSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
    goodsSelectParams() {
      return {
        minStock: 0.01,
      };
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      orderInfo: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        storeGuid: [
          {
            required: true,
            message: "请选择门店或仓库",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    handleAddItem(goodsInfo) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      // 创建列表备份
      let findItem = null;
      let tempItemList = this.toAny(JSON.stringify(this.editModel.itemList), []);
      tempItemList.forEach((item) => {
        if (item.goodsGuid == goodsInfo.guid) {
          findItem = item;
        }
      });
      if (!findItem) {
        findItem = {
          goodsGuid: goodsInfo.guid,
          skuGuid: goodsInfo.skuGuid,
          skuInfo: goodsInfo.skuInfo,
          goodsInfo: goodsInfo,
          goodsPrice: goodsInfo.retailPrice || 0,
          goodsCount: 1,
          optRemark: "手动添加",
        };
        tempItemList.unshift(findItem);
      }
      this.editModel.itemList = tempItemList;
    },
    getItemByGoodsGuid(goodsGuid) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let findItem;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.goodsGuid == goodsGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    deleteItemClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
      this.handleItemGoodsChange(item);
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
    },
    handleItemGoodsChange(item) {
      if (item.goodsCount < 0) {
        item.goodsCount = 0;
      }
      if (item.goodsPrice < 0) {
        item.goodsPrice = 0;
      }
      item.totalAmount = Number(Number(item.goodsPrice * item.goodsCount).toFixed(2));
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi("biz.warehouse.order.info.update", this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        }
      });
    },
    handleModel() {
      // nothing
    },
    fetchModel() {
      // 编辑
      this.loading = true;
      this.errorMsg = null;
      this.editModel = null;
      if (this.pageParams.guid) {
        return this.requestApi("biz.warehouse.order.info.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        })
          .then((resp) => {
            this.orderInfo = resp.data;
            return this.requestApi("biz.warehouse.order.item.list", {
              orderGuid: resp.data.guid,
              storeGuid: resp.data.storeGuid,
            }).then((listResp) => {
              this.editModel = Object.assign({}, defaultModel, resp.data, {
                itemList: (listResp.data.list || []).map((item) => {
                  item.isDelete = 0;
                  return item;
                }),
              });
              this.handleModel();
            });
          })
          .catch((err) => {
            this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.editModel = Object.assign({}, defaultModel);
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
